export const validatePhoneNumber = (value: string): boolean => {
    const phoneRegex = /^(0[35789]\d{8}|02\d{8,9})$/;
    return phoneRegex.test(value);
};
